import { NavLink } from 'react-router-dom'
import { axiosGet } from 'shared/api/axios'
import confirmDelete from 'shared/utils/confirmDelete'
import * as Icon from 'react-bootstrap-icons'
import { formatDate, stringToDate } from 'utils/dateUtils'
import { apiUrls, roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
  filter?: object
}

const getRows = async (props: getRowsProps) => {
  let getParams = {}
  if (props.filter !== undefined && Object.keys(props.filter).length > 0) {
    getParams['filter'] = props.filter
  }

  //TODO getParams cannot be passed here when you remove data from the table
  let response = await axiosGet(apiUrls.devices, getParams)

  const currentDate = new Date()
  let data = response.data

  const canEditAndDelete = hasAnyRole([roles.admin, roles.superAdmin])

  data.forEach((row: any, index: number, dataArray: any) => {
    if (row.is_replacement) {
      dataArray[index].action = (
        <ActionButtons
          buttons={[
            {
              type: 'r',
              url: 'device-replacement-detail/' + row.id,
            },
          ]}
        />
      )
      return
    }

    if (!canEditAndDelete) {
      dataArray[index].action = (
        <ActionButtons
          buttons={[
            {
              type: 'r',
              url: 'view-device/' + row.id,
            },
          ]}
        />
      )
    } else {
      dataArray[index].action = (
        <ActionButtons
          buttons={[
            {
              type: 'u',
              url: 'edit-device/' + row.id,
            },
            {
              type: 'd',
              id: dataArray[index].id,
              url: 'delete-device/' + row.id,
              setDeleteEntryId: props.setDeleteEntryId,
              setShowModal: props.setShowModal,
            },
          ]}
        />
      )
    }
  })

  return data
}

export default getRows
